import { render, staticRenderFns } from "./div-flex.vue?vue&type=template&id=767ca4b3&scoped=true"
import script from "./div-flex.vue?vue&type=script&lang=js"
export * from "./div-flex.vue?vue&type=script&lang=js"
import style0 from "./div-flex.vue?vue&type=style&index=0&id=767ca4b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767ca4b3",
  null
  
)

export default component.exports